import { render, staticRenderFns } from "./EquipmentLicensesPatentsEcology.vue?vue&type=template&id=78935c6c&scoped=true"
import script from "./EquipmentLicensesPatentsEcology.vue?vue&type=script&lang=js"
export * from "./EquipmentLicensesPatentsEcology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78935c6c",
  null
  
)

export default component.exports